(() => {
  'use strict';
  const selector='#MainContent table';
  function prepareTables(root=document){
    root.querySelectorAll(selector).forEach(table=>{
      if(table.hasAttribute('data-lifty-responsive-table')||table.closest('form[action="/cart"]'))return;
      const head=table.tHead?.rows[table.tHead.rows.length-1];
      if(!head){
        const rows=[...table.rows];
        if(rows.length&&rows.every(row=>row.cells.length===2&&[...row.cells].every(cell=>cell.colSpan===1&&cell.rowSpan===1)))table.setAttribute('data-lifty-key-value','');
        return;
      }
      if(!head||head.cells.length<2||head.cells.length>6)return;
      const columns=[...head.cells];
      const rows=[...table.tBodies].flatMap(body=>[...body.rows]);
      const isGroup=row=>row.cells.length===1&&row.cells[0].colSpan===columns.length&&row.cells[0].rowSpan===1;
      if(columns.some(cell=>cell.colSpan!==1)||!rows.length||rows.some(row=>!isGroup(row)&&([...row.cells].reduce((total,cell)=>total+cell.colSpan,0)!==columns.length||[...row.cells].some(cell=>cell.rowSpan!==1))))return;
      table.setAttribute('role','table');
      table.tHead.setAttribute('role','rowgroup');
      head.setAttribute('role','row');
      columns.forEach(cell=>cell.setAttribute('role','columnheader'));
      [...table.tBodies].forEach(body=>body.setAttribute('role','rowgroup'));
      rows.forEach(row=>{
        row.setAttribute('role','row');
        if(isGroup(row))row.setAttribute('data-lifty-table-group','');
        let columnIndex=0;
        [...row.cells].forEach(cell=>{
          if(!isGroup(row))cell.dataset.columnLabel=columns.slice(columnIndex,columnIndex+cell.colSpan).map(column=>column.textContent.trim()).join(' / ');
          columnIndex+=cell.colSpan;
          cell.setAttribute('role',cell.tagName==='TH'?'rowheader':'cell');
        });
      });
      table.setAttribute('data-lifty-responsive-table','');
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>prepareTables(),{once:true});
  else prepareTables();
  document.addEventListener('shopify:section:load',event=>prepareTables(event.target));
})();
